
import axios from "axios";
import { store } from "store";
import { configUpdate } from "store/config";
import { OutputBaseProps } from "utils/types/API";
import { ConfigItemProps } from ".";

type ApiConfigOutputProps = OutputBaseProps<{ item: ConfigItemProps }>

export const apiGetConfig = async () => {
    const res = (await axios.get<ApiConfigOutputProps>("/api/config"))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(configUpdate(res.data.item));
    }
    return res;
};